"use strict";

define('components/filter_bar/filters/datepicker_filters',['datepicker'], function() {
    var datePickerFiltersComponent = {
        initWithContext: function(context) {
            var fields = context.buttonbarNode.find('input.datepicker-field');

            // Initialize any datepicker fields
            if (Modernizr.touch && Modernizr.inputtypes.date) {
                fields.attr('type', 'date');
                return;
            }

            // Use a date picker for non-touch devices, regardless of support for the date type.
            fields.each(function() {
                var input = $(this);
                var value = input.val();

                if (value) {
                    var newValue = value.replace(/^\s*(\d\d(\d\d)?)-(\d\d?)-(\d\d?)\s*/, "$3/$4/$1");
                    input.val(newValue);
                }
            }).datepicker({
                format: 'mm/dd/yyyy',
                autoclose: true,
                todayBtn: 'linked',
                todayHighlight: true,
                assumeNearbyYear: true,
            }).on('changeDate', function() {
                var input = $(this);
                var value = input.val().trim();
                var filterName = input.attr('id');

                context.applyTextFilter(filterName, value);
                context.markDirtyState();
            });
        }
    };

    return datePickerFiltersComponent;
});

